import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie'
import axios from 'axios'
import { toast } from 'react-toastify'
import Select from 'react-select'
import Topbar from '../layouts/Topbar'
import Sidebar from '../layouts/Sidebar'
import { FaSave, FaSpinner, FaCheck, FaTimes, FaEye, FaCheckCircle, FaTimesCircle } from 'react-icons/fa'
import { useParams, useNavigate } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import '../../HR Manager/screens/EmployeeGoals.css'
import { useLocation } from 'react-router-dom';
import API_BASE_URL from '../../../config/api'
import { RiFilePdfLine } from 'react-icons/ri'
import {Link} from 'react-router-dom'

const COOPendingGoals = () => {
    const baseUrl = API_BASE_URL
    const { id } = useParams()
    const navigate = useNavigate()
    const location = useLocation();
    const employeeId = location.state?.employeeId || id; // fallback to URL param
    const [loading, setLoading] = useState(false)
    const [goals, setGoals] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 20;
    const [expandedTexts, setExpandedTexts] = useState({})
    const [modalOpen, setModalOpen] = useState(false)
    const [selectedGoal, setSelectedGoal] = useState(null)
    const [approvalLoading, setApprovalLoading] = useState(null); // goal id or null
    const [rejectModalOpen, setRejectModalOpen] = useState(false);
    const [rejectReason, setRejectReason] = useState('');
    const [rejectGoal, setRejectGoal] = useState(null);
    const [rejectSubmitting, setRejectSubmitting] = useState(false);
    const [rejectError, setRejectError] = useState(null);

    const handleViewGoal = (goal) => {
        setSelectedGoal(goal)
        setModalOpen(true)
    }

    const closeModal = () => {
        setModalOpen(false)
        setSelectedGoal(null)
    }

    const toggleTextExpansion = (goalId, field) => {
        setExpandedTexts(prev => ({
            ...prev,
            [`${goalId}-${field}`]: !prev[`${goalId}-${field}`]
        }))
    }

    const renderTruncatedText = (text, goalId, field, maxLength = 15) => {
        if (!text || text.length <= maxLength) return text

        const key = `${goalId || 'unknown'}-${field}`
        const isExpanded = expandedTexts[key]

        return (
            <span>
                {isExpanded ? text : `${text.substring(0, 10)}...`}
                <span
                    className="expand-dots"
                    onClick={() => toggleTextExpansion(goalId || 'unknown', field)}
                    title={isExpanded ? "Click to collapse" : "Click to expand"}
                >
                    {isExpanded ? " [collapse]" : ""}
                </span>
            </span>
        )
    }

    const handleApproveGoal = async (goal) => {
        setApprovalLoading(goal.id);
        try {
            const token = Cookies.get('token');
            await axios.post(`${baseUrl}/api/goals/${goal.id}/approval/`, { action: 'approve' }, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            toast.success('Goal approved!');
            // Refresh goals
            const response = await axios.get(`${baseUrl}/api/goals/pending/`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            const pendingGoals = Array.isArray(response.data) ? response.data.filter(goal => goal.approval_status === 'pending') : [];
            setGoals(pendingGoals);
        } catch (err) {
            console.log(err)
            toast.error(err.message || 'Failed to approve goal');
        } finally {
            setApprovalLoading(null);
        }
    };
    const openRejectModal = (goal) => {
        setRejectGoal(goal);
        setRejectReason('');
        setRejectError(null);
        setRejectModalOpen(true);
    };
    const closeRejectModal = () => {
        setRejectModalOpen(false);
        setRejectGoal(null);
        setRejectReason('');
        setRejectError(null);
    };
    const handleRejectSubmit = async (e) => {
        e.preventDefault();
        setRejectSubmitting(true);
        setRejectError(null);
        try {
            const token = Cookies.get('token');
            await axios.post(`${baseUrl}/api/goals/${rejectGoal.id}/approval/`, { action: 'reject', reason: rejectReason }, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            toast.success('Goal rejected!');
            // Refresh goals
            const response = await axios.get(`${baseUrl}/api/goals/pending/`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            const pendingGoals = Array.isArray(response.data) ? response.data.filter(goal => goal.approval_status === 'pending') : [];
            setGoals(pendingGoals);
            closeRejectModal();
        } catch (err) {

            setRejectError(err.message || 'Failed to reject goal');
        } finally {
            setRejectSubmitting(false);
        }
    };

    useEffect(() => {
        const fetchPendingGoals = async () => {
            setLoading(true)
            try {
                const token = Cookies.get('token')
                const response = await axios.get(`${baseUrl}/api/goals/pending/`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                })
                // Only keep goals with approval_status === 'pending'
                const pendingGoals = Array.isArray(response.data) ? response.data.filter(goal => goal.approval_status === 'pending') : [];
                setGoals(pendingGoals)
            } catch (err) {
                toast.error('Failed to fetch pending goals.')
            } finally {
                setLoading(false)
            }
        }
        fetchPendingGoals()
    }, [])

    // Reset to first page whenever goals list changes
    useEffect(() => {
        setCurrentPage(1);
    }, [goals]);

    const totalPages = Math.ceil(goals.length / rowsPerPage) || 1;
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentGoals = goals.slice(indexOfFirstRow, indexOfLastRow);

    const handlePageChange = (newPage) => {
        if (newPage < 1 || newPage > totalPages) return;
        setCurrentPage(newPage);
    };

    return (
        <>
            <Topbar />
            <Sidebar />
            <div className="employee-goals-container">
                <div className="hr-content-wrapper">
                <p style={{fontSize: '16px', fontWeight: '400', color: '#64748b'}}>View all pending KPIs for your department.</p>

                    {loading ? (
                        <div className="loading-state"><FaSpinner className="spinner" /> Loading pending KPIs...</div>
                    ) : (
                        <>
                            <div className="goals-table-wrapper">
                                <table className="goals-table">
                                    <thead>
                                        <tr>
                                            <th>Employee</th>
                                            <th>KRA</th>
                                            <th>Activity</th>
                                            <th>Stakeholder</th>
                                            <th>RAG</th>
                                            <th>Quarter</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {goals.length === 0 ? (
                                            <tr><td colSpan={7} className="empty-row">No pending KPIs found.</td></tr>
                                        ) : (
                                            currentGoals.map((goal, idx) => (
                                                <tr key={goal.id || idx}>
                                                    <td>{goal.employee_name}</td>
                                                    <td>
                                                        {renderTruncatedText(goal.key_result_area?.name || goal.name, goal.id || `${idx + indexOfFirstRow}`, 'kra')}
                                                    </td>
                                                    <td>
                                                        {renderTruncatedText(goal.activity, goal.id || `${idx + indexOfFirstRow}`, 'activity')}
                                                    </td>
                                                    <td>{goal.stakeholder}</td>
                                                    <td>
                                                        <div className="rag-bar-bg">
                                                            <div
                                                                className="rag-bar-fill"
                                                                style={{ backgroundColor: goal.progress_indicator, width: '100%' }}
                                                            >
                                                                <span className="rag-bar-label">{goal.rag_color || ''}</span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>{goal.quarter}</td>
                                                    <td>
                                                        <span className={`status-badge status-${goal.approval_status?.toLowerCase() || 'unknown'}`}>
                                                            {goal.approval_status === 'pending' && <FaSpinner className="pending-spinner" />}
                                                            {goal.approval_status ? goal.approval_status.charAt(0).toUpperCase() + goal.approval_status.slice(1) : ''}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <div className="goal-actions">
                                                            <button className="action-button view-button" title="View" onClick={() => handleViewGoal(goal)}>
                                                                <FaEye />
                                                            </button>
                                                            {goal.approval_status === 'pending' && (
                                                                <>
                                                                    <button className="action-button approve-button" title="Approve" onClick={() => handleApproveGoal(goal)} disabled={approvalLoading === goal.id}>
                                                                        {approvalLoading === goal.id ? <FaSpinner className="pending-spinner" /> : <FaCheckCircle style={{ color: '#22c55e' }} />}
                                                                    </button>
                                                                    <button className="action-button reject-button" title="Reject" onClick={() => openRejectModal(goal)}>
                                                                        <FaTimesCircle style={{ color: '#ef4444' }} />
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                                {goals.length > rowsPerPage && (
                                    <div className="pagination-controls" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', fontSize: 13 }}>
                                        <div>
                                            Showing {indexOfFirstRow + 1}-
                                            {Math.min(indexOfLastRow, goals.length)} of {goals.length} goals
                                        </div>
                                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                            <button
                                                type="button"
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                disabled={currentPage === 1}
                                                style={{
                                                    padding: '6px 10px',
                                                    fontSize: 13,
                                                    borderRadius: 6,
                                                    border: '1px solid #e2e8f0',
                                                    background: currentPage === 1 ? '#e5e7eb' : '#ffffff',
                                                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                                                }}
                                            >
                                                Previous
                                            </button>
                                            <span style={{ fontSize: 13 }}>
                                                Page {currentPage} of {totalPages}
                                            </span>
                                            <button
                                                type="button"
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                                style={{
                                                    padding: '6px 10px',
                                                    fontSize: 13,
                                                    borderRadius: 6,
                                                    border: '1px solid #e2e8f0',
                                                    background: currentPage === totalPages ? '#e5e7eb' : '#ffffff',
                                                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                                                }}
                                            >
                                                Next
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>

            {modalOpen && selectedGoal && (
                <div className="modal-overlay">
                    <div className="modal-content-employee-goal">
                        <div className="modal-header">
                            <h2>KPI Details</h2>
                            <button onClick={closeModal} className="modal-close-btn">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="goal-details-grid">
                                <div className="goal-detail-row">
                                    <label>Key Result Area:</label>
                                    <span>{selectedGoal.key_result_area?.name || selectedGoal.name}</span>
                                </div>
                                <div className="goal-detail-row">
                                    <label>Activity:</label>
                                    <span>{selectedGoal.activity}</span>
                                </div>
                                <div className="goal-detail-row">
                                    <label>Stakeholder:</label>
                                    <span>{selectedGoal.stakeholder}</span>
                                </div>
                                <div className="goal-detail-row">
                                    <label>Quarter:</label>
                                    <span>{selectedGoal.quarter}</span>
                                </div>
                                <div className="goal-detail-row">
                                    <label>RAG Color:</label>
                                    <div className="progress-indicator-display" style={{ backgroundColor: selectedGoal.progress_indicator || '#e5e7eb', width: '100%' }}>

                                    </div>
                                </div>
                                <div className="goal-detail-row">
                                    <label>Completion Status:</label>
                                    <span>
                                        {selectedGoal.status
                                            ? selectedGoal.status.charAt(0).toUpperCase() + selectedGoal.status.slice(1).replace(/_/g, ' ')
                                            : 'N/A'}
                                    </span>
                                </div>
                                <div className="goal-detail-row">
                                    <label>Is Overdue:</label>
                                    <span className={selectedGoal.is_overdue ? 'overdue-yes' : 'overdue-no'}>
                                        {selectedGoal.is_overdue ? 'Yes' : 'No'}
                                    </span>
                                </div>
                                <div className="goal-detail-row">
                                    <label>Approval Status:</label>
                                    <span style={{ color: '#ffc' }} className={`status-badge status-${selectedGoal.approval_status?.toLowerCase() || 'unknown'}`}>
                                        {selectedGoal.approval_status === 'pending' && <FaSpinner className="pending-spinner" />}
                                        {selectedGoal.approval_status ? selectedGoal.approval_status.charAt(0).toUpperCase() + selectedGoal.approval_status.slice(1) : 'N/A'}
                                    </span>
                                </div>
                                <div className="goal-detail-row">
                                    <label>Due Date:</label>
                                    <span>
                                        {selectedGoal.completion_date
                                            ? new Date(selectedGoal.completion_date).toLocaleDateString('en-GB')
                                            : 'N/A'}
                                    </span>
                                </div>
                                {selectedGoal.approval_status === 'rejected' && selectedGoal.rejected_reason && (
                                    <div className="goal-detail-row full-width">
                                        <label>Rejection Reason:</label>
                                        <span className="rejection-reason">{selectedGoal.rejected_reason}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button onClick={closeModal} className="modal-close-button">Close</button>
                        </div>
                    </div>
                </div>
            )}

            {rejectModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content-employee-goal" style={{ maxWidth: 480 }}>
                        <div className="modal-header">
                            <h2>Reject KPI</h2>
                            <button onClick={closeRejectModal} className="modal-close-btn">&times;</button>
                        </div>
                        <form onSubmit={handleRejectSubmit} className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                            <div className="goal-detail-row" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 6 }}>
                                <label style={{ fontWeight: 600, color: '#374151', marginBottom: 2 }}>Rejection Reason <span className="required">*</span></label>
                                <textarea
                                    name="rejection_reason"
                                    value={rejectReason}
                                    onChange={e => setRejectReason(e.target.value)}
                                    required
                                    className="form-input"
                                    placeholder="Enter reason for rejection..."
                                    rows={4}
                                    disabled={rejectSubmitting}
                                    style={{ borderRadius: 8, border: '2px solid #e5e7eb', fontSize: 16, padding: '12px 16px', minWidth: '90%' }}
                                />
                            </div>
                            {rejectError && <div className="error-state">{rejectError}</div>}
                            <div className="modal-actions">
                                <button
                                    type="submit"
                                    className="submit-button"
                                    style={{ width: '100%', fontWeight: 700, fontSize: 17, borderRadius: 8, padding: '14px 0', marginTop: 8, background: 'linear-gradient(135deg,#ef4444 0%, #f87171 100%)', color: '#fff' }}
                                    disabled={rejectSubmitting}
                                >
                                    {rejectSubmitting ? 'Rejecting...' : 'Reject KPI'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    )
}

export default COOPendingGoals
